import { PortfolioItem, WatchlistItem } from '@libs/api-reference';

import { TRADING_STATE_CODES } from '../../constants';

export type TransformTradePriceChangeDataType = {
  isin: string;
  Price: number;
  TPV: number;
  TPVP: number;
  DateIso: string;
  Trades: number;
  Low: number;
  High: number;
  TTQ: number;
};

export type TransformPreOpeningTradePriceChangeDataType = {
  isin: string;
  TOPVP: number;
  TOP: number;
};

function transformTradePriceChange(data: TransformTradePriceChangeDataType) {
  const {
    isin: isin,
    Price: lastTradePrice,
    TPV: referencePriceVariation,
    TPVP: referencePriceVariationPercentage,
    DateIso: lastTradeDate,
    Trades: totalNumberOfTrades,
    Low: lowestTradePrice,
    High: highestTradePrice,
    TTQ: totalNumberOfSharesTraded,
  } = data;

  return {
    isin,
    lastTradePrice,
    referencePriceVariation,
    referencePriceVariationPercentage,
    pricePercentage: referencePriceVariationPercentage,
    lastTradeDate,
    totalNumberOfTrades,
    highestTradePrice,
    lowestTradePrice,
    totalNumberOfSharesTraded,
  };
}

function transformPreOpeningTradePriceChange(
  data: TransformPreOpeningTradePriceChangeDataType
) {
  const {
    isin: isin,
    TOPVP: topVariationPercentage,
    TOP: theoricalOpeningPrice,
  } = data;

  return {
    isin,
    topVariationPercentage,
    pricePercentage: topVariationPercentage,
    theoricalOpeningPrice,
  };
}

function transformPricePercentage(
  symbol: (PortfolioItem | WatchlistItem) & { pricePercentage?: number }
) {
  let pricePercentage = symbol.referencePriceVariationPercentage;

  if (symbol.instrumentTradingState === TRADING_STATE_CODES.preOpening) {
    pricePercentage = symbol.topVariationPercentage as number;
  }

  symbol.pricePercentage = pricePercentage;
}

export {
  transformTradePriceChange,
  transformPreOpeningTradePriceChange,
  transformPricePercentage,
};
